var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCacEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/content/create_24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 9.08 0 10 0.92 10 9.98 0.94 9.06 0.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,11.25 L0,15 L3.75,15 L14.81,3.94 L11.06,0.19 L0,11.25 Z M2.92,13 L2,13 L2,12.08 L11.06,3.02 L11.98,3.94 L2.92,13 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71,2.63 L3.37,0.29 C3.17,0.09 2.92,0 2.66,0 C2.4,0 2.15,0.1 1.96,0.29 L0.13,2.12 L3.88,5.87 L5.71,4.04 C6.1,3.65 6.1,3.02 5.71,2.63 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6.0-Tech-Report---Report",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/content/create_24px",
    transform: "translate(-3.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Light-Color",
    transform: "translate(5.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Black-/-Disabled",
    mask: "url(#mask-2)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 101,
    height: 101
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Dark-Color",
    transform: "translate(3.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Black-/-Inactive",
    mask: "url(#mask-4)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 101,
    height: 101
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Dark-Color",
    transform: "translate(15.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Black-/-Inactive",
    mask: "url(#mask-6)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 101,
    height: 101
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCacEdit);
export default __webpack_public_path__ + "static/media/cac_edit.79754cad27ab2fd404bfc8fb8978262e.svg";
export { ForwardRef as ReactComponent };